import React, { Component } from 'react';
import { getAnswers, removeAnswer, getQuestion, removeQuestion, updateMatrix } from '../../../../services/formService';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { QuestionTypes } from '../../../../constants/QuestionTypes';
import MatrixQuestionActions from './MatrixQuestionActionMenu';
import { logActivity } from '../../../../services/utilService';

class TypeMatrix extends Component {
	state = {
		Widget_ID: this.props.Widget_ID,
		Question_ID: this.props.Question_ID,
		Question_Type_ID: QuestionTypes.Matrix,
		Question_Answers: [],
		Matrix_Questions: [],
		Matrix_Answers: [],
		Allow_Multiple_Selection: false,
		isTally: false,
		loading: false,
	};

	constructor(props) {
		super(props);
		this.handleSave = this.handleSave.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	async componentDidMount() {
		this.setState({ loading: true });
		// load matrix questions
		const { data } = await getQuestion(this.props.Widget_ID);
		let Matrix_Questions = [];
		if (data.length > 0) {
			let i = 0;
			for (; i < data.length; i++) {
				if (data[i].Linked_Question_ID === this.state.Question_ID) {
					Matrix_Questions = [
						...Matrix_Questions,
						{
							Question_ID: data[i].Question_ID,
							Question_Text: data[i].Question_Text,
							Question_Type_ID: data[i].Question_Type_ID,
							Description: data[i].Description,
						},
					];
					this.setState({ Matrix_Questions });
					if (data[i].Question_Type_ID === QuestionTypes.Numeric_Tally) {
						this.setState({ isTally: true });
					}
					this.setState({
						Allow_Multiple_Selection: data[i].Allow_Multiple_Selection ? true : false,
					});
				}
			}
		}

		// Load question answers
		let { data: Question_Answers } = await getAnswers(this.state.Question_ID);
		this.setState({ Question_Answers });

		// Load matrix answers
		let qus;
		let Matrix_Answers = [];
		for (qus of Matrix_Questions) {
			let { data: ans } = await getAnswers(qus.Question_ID);
			Matrix_Answers = [...Matrix_Answers, ans];
		}
		this.setState({ Matrix_Answers });
		this.setState({ loading: false });
	}

	async handleSave() {
		const{onSuccessfulSave} = this.props;
		let basicInfo = this.props.onSave();
		const { data } = await updateMatrix(this.props.Widget_ID, {
			...this.state,
			...basicInfo,
		});

		if (typeof data === 'string') {
			toaster('error', data);
			logActivity('/formBuilder','WIDGET_MATRIX_SAVE_FAILED');
		} else {
			toaster('success', 'Saved.');
			logActivity('/formBuilder','WIDGET_MATRIX_SAVE_SUCCESS');
			const { Question_ID, Question_Answers, Matrix_Questions, Matrix_Answers } = data;
			this.setState({ Question_ID });
			this.setState({ Question_Answers });
			this.setState({ Matrix_Questions });
			this.setState({ Matrix_Answers });
			onSuccessfulSave();
		}
	}

	handleDelete() {
		this.props.onRemove();
	}

	handleChange = (text, index, isAnswer) => {
		if (isAnswer) {
			const Question_Answers = [...this.state.Question_Answers];
			Question_Answers[index]['Answer_Text'] = text;
			this.setState({ Question_Answers });
		} else {
			const Matrix_Questions = [...this.state.Matrix_Questions];
			Matrix_Questions[index]['Question_Text'] = text;
			this.setState({ Matrix_Questions });
		}
	};

	handleRemove = async (index, isAnswer) => {
		if (isAnswer) {
			const answer = this.state.Question_Answers[index];

			const { data } = await removeAnswer(answer.Answer_ID);
			if (data.includes('Done')) {
				const Question_Answers = [...this.state.Question_Answers];
				Question_Answers.splice(index, 1);
				this.setState({ Question_Answers });
				toaster('success', 'Answer removed');
			} else {
				toaster('error', data);
			}
		} else {
			const question = this.state.Matrix_Questions[index];
			const Matrix_Questions = [...this.state.Matrix_Questions];
			Matrix_Questions.splice(index, 1);
			this.setState({ Matrix_Questions });

			if (question.Question_ID !== 0) {
				const { data } = await removeQuestion(-1, question.Question_ID);
				if (data.includes('Success')) {
					toaster('success', 'Matrix question removed');
				} else {
					toaster('error', data);
				}
			}
		}
	};

	handleAdd = (isAnswer) => {
		if (isAnswer) {
			const Question_Answers = [...this.state.Question_Answers, { Answer_ID: 0, Answer_Text: '' }];
			this.setState({ Question_Answers });

			if (this.state.Question_Type_ID === QuestionTypes.Matrix) {
				let qus;
				for (qus in this.state.Matrix_Questions) {
					let ans = { Answer_ID: 0, Deleted: 0 };
					let Matrix_Answers = [...this.state.Matrix_Answers];
					Matrix_Answers[qus].push(ans);
					this.setState({ Matrix_Answers });
				}
			}
		} else {
			const Matrix_Questions = [
				...this.state.Matrix_Questions,
				{
					Question_ID: 0,
					Question_Text: '',
					Question_Type_ID: this.state.isTally ? QuestionTypes.Numeric_Tally : QuestionTypes.Matrix,
					Linked_Question_ID: this.state.Question_ID,
          Description:"no description"
				},
			];
			this.setState({ Matrix_Questions });

			let ans;
			let mAns = [];
			for (ans in this.state.Question_Answers) {
				mAns.push({ Answer_ID: 0, Deleted: 0 });
			}
			const Matrix_Answers = [...this.state.Matrix_Answers, mAns];
			this.setState({ Matrix_Answers });
		}
	};

	handleComplexQuestionType = async (type) => {
		let { isTally, Allow_Multiple_Selection } = this.state;
		if (type === 'single') {
			isTally = false;
			Allow_Multiple_Selection = false;
		} else if (type === 'multiple') {
			isTally = false;
			Allow_Multiple_Selection = true;
		} else {
			isTally = true;
			Allow_Multiple_Selection = false;
		}

		let Matrix_Questions = [...this.state.Matrix_Questions];
		Matrix_Questions.forEach((q) => {
			q.Question_Type_ID = isTally ? QuestionTypes.Numeric_Tally : QuestionTypes.Matrix;
		});

		this.setState({ Allow_Multiple_Selection,isTally,Matrix_Questions });
	
	};

	handleCheckChange = (idx, idx1) => {
		let Matrix_Answers = [...this.state.Matrix_Answers];
		Matrix_Answers[idx][idx1].Deleted = Matrix_Answers[idx][idx1].Deleted == null ? false : null;
		this.setState({ Matrix_Answers });
	};

	handleDescriptionChange = (idx, descr) => {
		const Matrix_Questions = [...this.state.Matrix_Questions];
		Matrix_Questions[idx]['Description'] = descr;
		this.setState({ Matrix_Questions });
	};

	render() {
		if (this.state.loading) return <div className='center'>Loading...</div>;

		let { Question_Answers, Matrix_Questions, Question_ID, Widget_ID } = this.state;
		return (
			<React.Fragment>
				<div key={Question_ID}>
					<div className='form-check form-check-inline'>
						<input
							type='radio'
							className='form-check-input'
							id={Question_ID + 'single_selection'}
							name={Question_ID + 'matrixType'}
							value='single'
							checked={!this.state.Allow_Multiple_Selection && !this.state.isTally}
							onChange={(e) => this.handleComplexQuestionType(e.target.value)}
						/>
						<label htmlFor='single_selection' className='form-check-label'>
							Single selection
						</label>
					</div>

					<div className='form-check form-check-inline'>
						<input
							type='radio'
							className='form-check-input'
							id={Question_ID + 'multiple_selection'}
							name={Question_ID + 'matrixType'}
							value='multiple'
							checked={this.state.Allow_Multiple_Selection}
							onChange={(e) => this.handleComplexQuestionType(e.target.value)}
						/>
						<label htmlFor='multiple_selection' className='form-check-label'>
							Allow multiple selection
						</label>
					</div>

					<div className='form-check form-check-inline'>
						<input
							type='radio'
							className='form-check-input'
							id={Question_ID + 'mTally'}
							name={Question_ID + 'matrixType'}
							value='tally'
							checked={this.state.isTally}
							onChange={(e) => this.handleComplexQuestionType(e.target.value)}
						/>
						<label htmlFor='mTally' className='form-check-label'>
							Numeric Tally
						</label>
					</div>
					<table className='table table-bordered'>
						<thead>
							<tr>
								<th></th>
								{Question_Answers.map((row, idx) => {
									return (
										<th scope='col' key={idx}>
											<div className='input-group'>
												<input className='form-control' value={row.Answer_Text} onChange={(e) => this.handleChange(e.target.value, idx, true)} />
												<div className='input-group-append'>
													<button className='btn btn-danger btn-sm' onClick={() => this.handleRemove(idx, true)}>
														<FontAwesomeIcon icon={faTimes} />
													</button>
												</div>
											</div>
										</th>
									);
								})}
								<th scope='col' className='text-center'>
									<button className='btn btn-success btn-sm' onClick={() => this.handleAdd(true)}>
										<FontAwesomeIcon icon={faPlus} />
									</button>
								</th>
							</tr>
						</thead>
						<tbody>
							{Matrix_Questions.map((row, idx) => {
								return (
									<tr key={'q' + idx}>
										<th scope='row'>
											<input className='form-control' value={row.Question_Text} onChange={(e) => this.handleChange(e.target.value, idx, false)} />
										</th>
										{Question_Answers.map((row1, idx1) => {
											return (
												<td key={'c' + idx1}>
													<input type='checkbox' checked={this.state.Matrix_Answers[idx][idx1].Deleted == null ? false : true} onChange={() => this.handleCheckChange(idx, idx1)} />
												</td>
											);
										})}

										<td className='text-center'>
											<MatrixQuestionActions key={'matQaction' + idx} Index={idx} Question={row} handleRemove={this.handleRemove} handleChange={this.handleDescriptionChange} />
										</td>
									</tr>
								);
							})}
							<tr>
								<th scope='row' className='text-center'>
									<button className='btn btn-success btn-sm' onClick={() => this.handleAdd(false)}>
										<FontAwesomeIcon icon={faPlus} />
									</button>
								</th>
							</tr>
						</tbody>
					</table>
				</div>

				<div className='float-right'>
					<button className='btn btn-outline-primary m-2' onClick={this.handleSave}>
						Save
					</button>
					<button className='btn btn-outline-danger' onClick={this.handleDelete}>
						Delete
					</button>
				</div>
				<ToastContainer/>
			</React.Fragment>
		);
	}
}

export default TypeMatrix;
